import React, { useEffect, useState, useRef } from "react";
import avatar from "./asserts/def-ava.png";
import { useNavigate } from "react-router-dom";
import { authFetch } from "./auth";

const SkydiverProfile = () => {
  const navigate = useNavigate();
  const [datas, setData] = useState([]);
  const [fallMode, setFallMode] = useState("skydive"); // skydive | tunnel
  const [placeMode, setPlaceMode] = useState("dropzone"); // dropzone | tunnel
  const [mode, setMode] = useState("skydive"); // skydive | tunnel
  const [locationMode, setLocationMode] = useState("dropzone"); // dropzone | tunnel
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const [editOpen, setEditOpen] = useState(false);
  const [editName, setEditName] = useState("");
  const [editCanopy, setEditCanopy] = useState("");

  const [avatarFile, setAvatarFile] = useState(null);
  const fileInputRef = useRef(null);
  const [avatarUploading, setAvatarUploading] = useState(false);

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState(null);
  const [savingPassword, setSavingPassword] = useState(false);
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);

  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [copied, setCopied] = useState(false);


  const [loading, setLoading] = useState(true);

  const [friendsModalOpen, setFriendsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("friends"); // friends | global

  const [friends, setFriends] = useState([]);
  const [users, setUsers] = useState([]);

  const [search, setSearch] = useState("");
  const [searchType, setSearchType] = useState("name"); // name | dropzone

  const [dropzones, setDropzones] = useState([]);
  const [filteredDropzones, setFilteredDropzones] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  const [editHomeDz, setEditHomeDz] = useState("");
  const [selectedDropzone, setSelectedDropzone] = useState(null);
  const [homeDzJustSelected, setHomeDzJustSelected] = useState(false);

  const dropdownRef = useRef(null);
  const [showHomeDzDropdown, setShowHomeDzDropdown] = useState(false);
  const [filteredHomeDz, setFilteredHomeDz] = useState([]);

const selectDropzone = (dz) => {
  setEditHomeDz(dz.name);
  setSelectedDropzone(dz);

  setShowDropdown(false);

  // 👇 убрать фокус с input
  document.activeElement.blur();
};

  useEffect(() => {
    const fetchDropzones = async () => {
      try {
        const res = await authFetch("/api/dropzones");
        const data = await res.json();

        setDropzones(data);
      } catch (e) {
        console.error(e);
      }
    };

    fetchDropzones();
  }, []);

  const handleDropzoneSearch = (value) => {
    setEditHomeDz(value);
    setSelectedDropzone(null);

    const filtered = dropzones.filter((dz) =>
      (dz.name || "").toLowerCase().includes(value.toLowerCase()) ||
      (dz.city || "").toLowerCase().includes(value.toLowerCase())
    );

    setFilteredDropzones(filtered);
    setShowDropdown(true);
  };

  const selectHomeDropzone = (dz) => {
    setEditHomeDz(dz.name);
    setSelectedDropzone(dz);

    setHomeDzJustSelected(true);

    setShowHomeDzDropdown(false);
  };
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleHomeDzSearch = (value) => {
    setEditHomeDz(value);

    // пользователь начал печатать руками —
    // значит выбор больше невалиден
    setSelectedDropzone(null);

    const filtered = dropzones.filter((dz) =>
      dz.name.toLowerCase().includes(value.toLowerCase()) ||
      dz.city?.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredHomeDz(filtered);
    setShowHomeDzDropdown(true);
  };

  const loadFriends = async () => {
    const res = await authFetch("/api/user/friends");
    const data = await res.json();
    setFriends(data);
    // setUsers(data);
  };

  const loadAll = async () => {
    const res = await authFetch("/api/user/all");
    const data = await res.json();
    setUsers(data);
  };

  const searchUsers = async () => {
    const res = await authFetch(
      `/api/user/search?query=${search}&type=${searchType}`
    );
    const data = await res.json();
    setUsers(data);
  };

  const addFriend = async (userId) => {
    await authFetch("/api/user/friends/add/" + userId, { method: "POST" });
    loadAll();
    loadFriends();
  };

  const switchWrapper = {
    display: "flex",
    background: "#1F2937",
    borderRadius: "999px",
    padding: "3px",
    width: "fit-content",
  };

  const switchBtn = (active) => ({
    padding: "4px 10px",
    borderRadius: "999px",
    border: "none",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "600",
    background: active ? "#374151" : "transparent",
    color: active ? "#fff" : "#9CA3AF",
    transition: "all 0.2s ease",
  });
  const switchTextStyle = {
    cursor: "pointer",
    transition: "opacity 0.2s ease",
  };

  const activeTextStyle = {
    color: "#F3F4F6",
    fontWeight: "600",
  };

  const inactiveTextStyle = {
    color: "#6B7280",
    fontWeight: "500",
  };

  const removeFriend = async (removeId) => {
    await fetch(`/api/user/friends/remove/${removeId}`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token")
      }
    });
    loadAll();
    loadFriends();
  };

  const formatMinutes = (totalMinutes) => {
    if (!totalMinutes) return "0 мин";

    const totalSeconds = totalMinutes * 60;

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hours} ч ${minutes} мин ${seconds} сек`;
  };

  // ✅ ТОЛЬКО это добавлено
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const backButton = {
    backgroundColor: "rgba(31, 41, 55, 0.8)",
    color: "#F3F4F6",
    padding: "10px 20px",
    border: "1px solid rgba(255,255,255,0.1)",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    borderRadius: "8px",
    textAlign: "center",
    display: "block",
    width: isMobile ? "180px" : "220px", // чуть меньше на мобиле
    margin: "20px auto", // по центру горизонтально
    position: "relative", // чтобы оставалась в потоке страницы
  };
  useEffect(() => {
    if (friendsModalOpen) {
      loadFriends();
      loadAll();
      // searchUsers();
    }
  }, [friendsModalOpen]);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (!friendsModalOpen) return;

    if (activeTab === "friends") {
      loadFriends();
    } else {
      loadAll();
    }
  }, [activeTab, friendsModalOpen]);

  const handleCopyLink = async () => {
    try {
      // Если браузер поддерживает Clipboard API и страница в безопасном контексте
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(publicUrl);
      } else {
        // Fallback для небезопасного контекста (HTTP) или старых браузеров
        const textArea = document.createElement("textarea");
        textArea.value = publicUrl;
        textArea.style.position = "fixed"; // чтобы не скроллилось
        textArea.style.left = "-9999px"; // чтобы было вне видимой области
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        const successful = document.execCommand("copy");
        document.body.removeChild(textArea);

        if (!successful) throw new Error("Fallback copy failed");
      }

      // Если удалось скопировать
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);

    } catch (err) {
      alert("Не удалось скопировать ссылку");
      console.error(err);
    }
  };


  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login", { replace: true });
  };

  const handleChangePassword = async () => {
    setPasswordError(null);

    if (!currentPassword || !newPassword || !confirmPassword) {
      setPasswordError("Заполните все поля");
      return;
    }

    if (newPassword.length < 8) {
      setPasswordError("Пароль должен быть не короче 8 символов");
      return;
    }

    if (newPassword !== confirmPassword) {
      setPasswordError("Пароли не совпадают");
      return;
    }

    try {
      setSavingPassword(true);

      const res = await authFetch("/api/personaldata/password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          currentPassword,
          newPassword,
        }),
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.message);
      }

      alert("Пароль успешно изменён");

      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");

    } catch (e) {
      setPasswordError(e.message || "Ошибка смены пароля");
    } finally {
      setSavingPassword(false);
    }
  };

  const handleSaveProfile = async () => {
    try {
      if (editHomeDz && !selectedDropzone) {
        alert("Выберите домашнюю дропзону из списка");
        return;
      }
      const res = await authFetch("/api/personaldata", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          fullname: editName,
          currentCanopy: editCanopy,
          dropzone: editHomeDz,
        }),
      });

      if (!res.ok) throw new Error();

      const updated = await res.json();
      setData(updated);
      setEditOpen(false);
    } catch (e) {
      alert("Не удалось сохранить изменения профиля");
    }
  };

  const handleAvatarUpload = async () => {
    if (!avatarFile) return;

    const formData = new FormData();
    formData.append("file", avatarFile);

    try {
      setAvatarUploading(true);

      const res = await authFetch("/api/personaldata/avatar", {
        method: "POST",
        body: formData,
      });

      if (!res.ok) throw new Error();

      const data = await res.json();

      // обновляем аватар в профиле
      setData(prev => ({
        ...prev,
        avatarPath: data.avatarPath + "?t=" + Date.now(),
      }));

      setAvatarFile(null);
      setEditOpen(false);
    } catch (e) {
      alert("Не удалось загрузить аватар");
    } finally {
      setAvatarUploading(false);
    }
  };


  useEffect(() => {
    authFetch("/api/personaldata")
      .then(res => res.json())
      .then(data => {
        setData(data);
        setLoading(false);
      });
  }, []);

  // Закрытие меню при клике вне его
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const publicUrl = datas?.publicId
    ? `${window.location.origin}/u/${datas.publicId}`
    : "";

  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "40px 20px",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        color: "#F3F4F6",
        display: "flex",
        justifyContent: "center",
        background: "transparent",
        position: "relative"
      }}
    >

      <div style={{ width: "100%", maxWidth: "1100px", position: "relative" }}>
        {/* HEADER */}
        <div style={{
          ...headerStyle,
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "center" : "flex-start",
          textAlign: isMobile ? "center" : "left"
        }}>
          <img
            src={datas.avatarPath || avatar}
            alt="Аватар"
            style={{
              width: "160px",
              height: "160px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "3px solid #10B981",
            }}
          />

          <div style={{ flex: 1 }}>
            <h2
              style={{
                ...nameStyle, fontSize: isMobile ? "22px" : "30px"
              }}
            >
              <strong>{datas.fullname}</strong>
            </h2>
            <table style={tableStyle}>
              <tbody>
                <tr>
                  <td>Общее количество прыжков:</td>
                  <td><strong>{datas.jumpCount}</strong></td>
                </tr>
                <tr>
                  <td>Текущий основной купол:</td>
                  <td><strong>{datas.currentCanopy}</strong></td>
                </tr>
                <tr>
                  <td>Домашняя дропзона:</td>
                  <td><strong>{datas.dropzone}</strong></td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Меню профиля с иконкой человека */}
          <div
            style={{
              position: "absolute",
              top: "15px",
              right: "15px",
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
            ref={menuRef}
          >
            {/* Кнопка редактирования */}
            <button
              onClick={() => {
                setEditName(datas.fullname || "");
                setEditCanopy(datas.currentCanopy || "");
                setEditOpen(true);
                setEditHomeDz(datas.dropzone || "");

                const existingDz = dropzones.find(
                  dz => dz.name === datas.dropzone
                );

                setSelectedDropzone(existingDz || null);
              }}
              title="Редактировать профиль"
              style={{
                background: "rgba(31, 41, 55, 0.8)",
                border: "2px solid #38BDF8",
                borderRadius: "50%",
                width: "45px",
                height: "45px",
                cursor: "pointer",
                fontSize: "20px",
                color: "#E5E7EB",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.2s",
              }}
            >
              ✏️
            </button>

            {/* Меню профиля */}
            <button
              onClick={() => setMenuOpen(prev => !prev)}
              style={{
                background: "rgba(31, 41, 55, 0.8)",
                border: "2px solid #10B981",
                borderRadius: "50%",
                width: "45px",
                height: "45px",
                cursor: "pointer",
                fontSize: "24px",
                color: "#F3F4F6",
              }}
            >
              👤
            </button>
            {menuOpen && (
              <div
                style={{
                  position: "absolute",
                  top: "55px",
                  right: "0",
                  background: "rgba(17, 24, 39, 0.95)",
                  borderRadius: "12px",
                  padding: "10px",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.5)",
                  zIndex: 1000,
                  minWidth: "170px"
                }}
              >
                <div
                  style={menuItemStyle}
                  onClick={() => {
                    setShareModalOpen(true);
                    setMenuOpen(false);
                  }}
                >
                  🔗 Поделиться
                </div>
                <div style={menuItemStyle} onClick={() => {
                  setFriendsModalOpen(true);
                  setMenuOpen(false);
                }}>
                  👥 Друзья
                </div>
                <div style={menuItemStyle} onClick={handleLogout}>
                  🚪 Выход
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Content blocks grid */}
        {/* Content blocks grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
            gap: "30px",
          }}
        >
          {/* ===== СТАТИСТИКА ===== */}
          <div style={sectionStyle}>
            <h3 style={{ ...sectionTitleStyle, display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>

              <span
                onClick={() => setMode("skydive")}
                style={{
                  ...switchTextStyle,
                  ...(mode === "skydive" ? activeTextStyle : inactiveTextStyle)
                }}
              >
                Свободное падение
              </span>

              <span style={{ color: "#6B7280" }}>/</span>

              <span
                onClick={() => setMode("tunnel")}
                style={{
                  ...switchTextStyle,
                  ...(mode === "tunnel" ? activeTextStyle : inactiveTextStyle)
                }}
              >
                Аэротруба
              </span>

            </h3>

            <table style={tableStyle}>
              <tbody>

                {mode === "skydive" ? (
                  <>
                    <tr>
                      <td>Общее время:</td>
                      <td><strong>{datas.freefallTime}</strong></td>
                    </tr>
                    <tr>
                      <td>В этом году:</td>
                      <td><strong>{datas.freefallTimeAtYear}</strong></td>
                    </tr>
                    <tr>
                      <td>Самое высокое отделение:</td>
                      <td><strong>{datas.maxHeight} м</strong></td>
                    </tr>
                    <tr>
                      <td>Самое низкое раскрытие:</td>
                      <td><strong>{datas.minDeploy} м</strong></td>
                    </tr>
                    <tr>
                      <td>Макс. скорость:</td>
                      <td><strong>{datas.maxSpeed} км/ч</strong></td>
                    </tr>
                  </>
                ) : (
                  <>
                    <tr>
                      <td>Общее время налета в трубе:</td>
                      <td><strong>{formatMinutes(datas.tunnelAllTime) || 0}</strong></td>
                    </tr>
                    <tr>
                      <td>Время налета в этом году:</td>
                      <td><strong>{formatMinutes(datas.tunnelYearTime) || 0}</strong></td>
                    </tr>
                  </>
                )}

              </tbody>
            </table>
          </div>

          {/* ===== ТИПЫ ПРЫЖКОВ ===== */}
          <div style={sectionStyle}>
            <h3 style={sectionTitleStyle}>Типы прыжков</h3>
            {loading ? (
              <p>Загрузка...</p>
            ) : datas.jumpTypes && datas.jumpTypes.length > 0 ? (
              <table style={tableStyle}>
                <tbody>
                  {datas.jumpTypes.map((type, index) => (
                    <tr key={index}>
                      <td>{type.jumpType}:</td>
                      <td><strong>{type.count}</strong></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p style={{ opacity: 0.7 }}>Похоже, данных нет</p>
            )}
          </div>

          {/* ===== ДРОПЗОНЫ / АЭРОТРУБЫ ===== */}
          <div style={sectionStyle}>
            <h3 style={{ ...sectionTitleStyle, display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>

              <span
                onClick={() => setLocationMode("dropzone")}
                style={{
                  ...switchTextStyle,
                  ...(locationMode === "dropzone" ? activeTextStyle : inactiveTextStyle)
                }}
              >
                Дропзоны
              </span>

              <span style={{ color: "#6B7280" }}>/</span>

              <span
                onClick={() => setLocationMode("tunnel")}
                style={{
                  ...switchTextStyle,
                  ...(locationMode === "tunnel" ? activeTextStyle : inactiveTextStyle)
                }}
              >
                Аэротрубы
              </span>

            </h3>

            {locationMode === "dropzone" ? (
              datas.dropzones ? (
                <table style={tableStyle}>
                  <tbody>
                    {datas.dropzones.map((dz, index) => (
                      <tr key={index}>
                        <td>{dz.dropzoneName}:</td>
                        <td><strong>{dz.count}</strong></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p>Загрузка...</p>
              )
            ) : (
              datas.tunnels ? (
                <table style={tableStyle}>
                  <tbody>
                    {datas.tunnels.map((tunnel, index) => (
                      <tr key={index}>
                        <td>{tunnel.windtunnelName}:</td>
                        <td><strong>{tunnel.count}</strong></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p>Загрузка...</p>
              )
            )}
          </div>

          {/* ===== ПАРАШЮТНЫЕ СИСТЕМЫ ===== */}
          <div style={sectionStyle}>
            <h3 style={sectionTitleStyle}>Парашютные системы</h3>
            {datas.canopyTypes ? (
              <table style={tableStyle}>
                <tbody>
                  {datas.canopyTypes.map((type, index) => (
                    <tr key={index}>
                      <td>{type.canopyType}:</td>
                      <td><strong>{type.count}</strong></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>Загрузка...</p>
            )}
          </div>
        </div>

        <div style={{ textAlign: "center", marginTop: "30px" }}>
          <button style={{ ...backButton, width: isMobile ? "100%" : "auto" }}
            onClick={() => navigate("/")}>
            ⬅ На главную
          </button>
        </div>
      </div>

      {editOpen && (
        <div style={modalOverlayStyle} onClick={() => setEditOpen(false)}>
          <div
            style={modalStyle}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={modalTitleStyle}>Редактирование профиля</h3>

            <label style={labelStyle}>
              Имя пользователя
              <input
                value={editName}
                onChange={(e) => setEditName(e.target.value)}
                style={inputStyle}
              />
            </label>

            <label style={labelStyle}>
              Текущий основной купол
              <input
                value={editCanopy}
                onChange={(e) => setEditCanopy(e.target.value)}
                style={inputStyle}
              />
            </label>

            {/* Выбор домашней дропзоны */}
            <label style={labelStyle}>
              Домашняя дропзона

              <div
                style={{ position: "relative", width: "100%", marginTop: "6px" }}
                ref={dropdownRef}
                onClick={(e) => e.stopPropagation()}
              >
                <input
                  value={editHomeDz}
                  onChange={(e) => handleDropzoneSearch(e.target.value)}
                  onFocus={() => {
                    if (homeDzJustSelected) {
                      setHomeDzJustSelected(false);
                      return;
                    }

                    setShowHomeDzDropdown(true);
                    setFilteredHomeDz(dropzones);
                  }}
                  style={{
                    ...inputStyle,
                    border:
                      editHomeDz && !selectedDropzone
                        ? "1px solid #EF4444"
                        : inputStyle.border
                  }}
                  placeholder="Начните вводить название..."
                />

                {showDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      background: "#111827",
                      borderRadius: "8px",
                      marginTop: "4px",
                      maxHeight: "220px",
                      overflowY: "auto",
                      zIndex: 1000,
                      boxShadow: "0 8px 20px rgba(0,0,0,0.5)"
                    }}
                  >
                    {(editHomeDz.trim() === ""
                      ? dropzones
                      : filteredDropzones
                    ).map((dz, i) => (
                      <div
                        key={i}
                        onClick={(e) => {
  e.stopPropagation();
  selectDropzone(dz);
}}
                        style={{
                          padding: "10px",
                          cursor: "pointer",
                          borderBottom: "1px solid #1F2937"
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#1F2937")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "transparent")
                        }
                      >
                        {dz.name} ({dz.city}, {dz.country})
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {editHomeDz && !selectedDropzone && (
                <div
                  style={{
                    color: "#F87171",
                    fontSize: "12px",
                    marginTop: "6px"
                  }}
                >
                  Выберите дропзону из списка
                </div>
              )}
            </label>

            {/* Аватар */}
            <div style={{ marginTop: "10px" }}>
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={(e) => setAvatarFile(e.target.files[0])}
              />

              <button
                onClick={() => fileInputRef.current.click()}
                style={{
                  padding: "10px",
                  borderRadius: "8px",
                  border: "1px solid rgba(255,255,255,0.2)",
                  backgroundColor: "rgba(31, 41, 55, 0.9)",
                  color: "#F3F4F6",
                  cursor: "pointer",
                  width: "100%",
                  marginBottom: "6px",
                }}
              >
                🖼 Изменить аватар
              </button>

              {avatarFile && (
                <div style={{ fontSize: "13px", opacity: 0.85 }}>
                  Выбран файл: <strong>{avatarFile.name}</strong>
                </div>
              )}

              {avatarFile && (
                <button
                  onClick={handleAvatarUpload}
                  disabled={avatarUploading}
                  style={{
                    marginTop: "10px",
                    padding: "10px",
                    width: "100%",
                    borderRadius: "8px",
                    border: "none",
                    backgroundColor: "#38BDF8",
                    color: "#022C22",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  {avatarUploading ? "Загрузка..." : "Установить как новый аватар"}
                </button>
              )}
            </div>

            <button
              onClick={() => setPasswordModalOpen(true)}
              style={{
                marginTop: "12px",
                padding: "10px",
                width: "100%",
                borderRadius: "8px",
                border: "1px solid rgba(255,255,255,0.2)",
                backgroundColor: "rgba(55, 65, 81, 0.9)",
                color: "#F3F4F6",
                fontWeight: "500",
                cursor: "pointer",
              }}
            >
              🔐 Сменить пароль
            </button>


            <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
              <button style={saveBtnStyle} onClick={handleSaveProfile}>
                💾 Сохранить
              </button>
              <button style={cancelBtnStyle} onClick={() => setEditOpen(false)}>
                Отмена
              </button>
            </div>
          </div>
        </div>
      )}

      {passwordModalOpen && (
        <div
          style={modalOverlayStyle}
          onClick={() => {
            setPasswordModalOpen(false);
            setCurrentPassword("");
            setNewPassword("");
            setConfirmPassword("");
            setPasswordError(null);
          }}
        >
          <div
            style={modalStyle}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={modalTitleStyle}>Смена пароля</h3>

            <label style={labelStyle}>
              Текущий пароль
              <input
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                style={inputStyle}
              />
            </label>

            <label style={labelStyle}>
              Новый пароль
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                style={inputStyle}
              />
            </label>

            <label style={labelStyle}>
              Повторите новый пароль
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                style={inputStyle}
              />
            </label>

            {passwordError && (
              <div
                style={{
                  color: "#F87171",
                  fontSize: "13px",
                  marginBottom: "10px",
                }}
              >
                {passwordError}
              </div>
            )}

            <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
              <button
                style={{
                  flex: 1,
                  padding: "12px",
                  borderRadius: "10px",
                  border: "none",
                  backgroundColor: "#F59E0B",
                  color: "#111827",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
                onClick={handleChangePassword}
                disabled={savingPassword}
              >
                {savingPassword ? "Изменение..." : "Сохранить"}
              </button>

              <button
                style={cancelBtnStyle}
                onClick={() => {
                  setPasswordModalOpen(false);
                  setCurrentPassword("");
                  setNewPassword("");
                  setConfirmPassword("");
                  setPasswordError(null);
                }}
              >
                Отмена
              </button>
            </div>
          </div>
        </div>
      )}

      {shareModalOpen && (
        <div
          style={modalOverlayStyle}
          onClick={() => {
            setShareModalOpen(false);
            setCopied(false);
          }}
        >
          <div
            style={modalStyle}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={modalTitleStyle}>Поделиться профилем</h3>

            <input
              type="text"
              value={publicUrl}
              readOnly
              style={{
                ...inputStyle,
                marginBottom: "15px",
                cursor: "pointer"
              }}
              onClick={(e) => e.target.select()}
            />

            <button
              onClick={handleCopyLink}
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "10px",
                border: "none",
                backgroundColor: "#10B981",
                color: "white",
                fontWeight: "600",
                cursor: "pointer"
              }}
            >
              {copied ? "✅ Скопировано!" : "📋 Скопировать"}
            </button>

            <button
              onClick={() => {
                setShareModalOpen(false);
                setCopied(false);
              }}
              style={{
                ...cancelBtnStyle,
                marginTop: "12px",
                width: "100%"
              }}
            >
              Закрыть
            </button>
          </div>
        </div>
      )}


      {friendsModalOpen && (
        <div
          onClick={() => setFriendsModalOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
            padding: "10px"
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "100%",
              maxWidth: "900px",
              maxHeight: "90vh",
              overflowY: "auto",
              background: "#111827",
              borderRadius: "16px",
              padding: "20px",
              color: "#fff",
              boxSizing: "border-box"
            }}
          >
            <h2 style={{ textAlign: "center", marginBottom: "15px" }}>
              👥 Друзья
            </h2>

            {/* ТАБЫ */}
            <div key={activeTab} style={{
              display: "flex",
              gap: "10px",
              marginBottom: "15px",
              justifyContent: "center"
            }}>
              <button
                onClick={() => setActiveTab("friends")}
                style={{
                  padding: "8px 16px",
                  borderRadius: "8px",
                  border: activeTab === "friends" ? "2px solid #FFD700" : "none",
                  background: "#333",
                  color: "#fff",
                  cursor: "pointer"
                }}
              >
                Мои друзья
              </button>

              <button
                onClick={() => setActiveTab("global")}
                style={{
                  padding: "8px 16px",
                  borderRadius: "8px",
                  border: activeTab === "global" ? "2px solid #FFD700" : "none",
                  background: "#333",
                  color: "#fff",
                  cursor: "pointer"
                }}
              >
                Глобальный поиск
              </button>
            </div>

            {/* ПОИСК */}
            <div style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              marginBottom: "15px",
              justifyContent: "center"
            }}>
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Поиск..."
                style={{
                  padding: "8px",
                  borderRadius: "8px",
                  border: "none",
                  width: "200px"
                }}
              />

              <select
                value={searchType}
                onChange={(e) => setSearchType(e.target.value)}
                style={{
                  padding: "8px",
                  borderRadius: "8px"
                }}
              >
                <option value="name">Имя</option>
                <option value="dropzone">Дропзона</option>
              </select>

              <button
                onClick={searchUsers}
                style={{
                  padding: "8px 16px",
                  borderRadius: "8px",
                  background: "#FFD700",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "bold"
                }}
              >
                Поиск
              </button>
            </div>

            {/* СПИСОК */}
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {(activeTab === "friends" ? friends : users).map((user) => (
                <div
                  key={user.id + activeTab}
                  style={{
                    background: "#1F2937",
                    padding: "14px",
                    borderRadius: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "12px",
                    flexWrap: "wrap"
                  }}
                >
                  {/* ЛЕВАЯ ЧАСТЬ - ИМЯ */}
                  <div style={{ minWidth: "180px" }}>
                    <div style={{ fontWeight: "700", fontSize: "15px" }}>
                      {user.fullname}
                    </div>
                  </div>

                  {/* ДРОПЗОНА */}
                  <div style={{ minWidth: "160px" }}>
                    <div style={{ fontSize: "13px", color: "#9CA3AF" }}>
                      Дропзона
                    </div>
                    <div>{user.dropzone || "-"}</div>
                  </div>

                  {/* ПАРАШЮТНАЯ СИСТЕМА */}
                  <div style={{ minWidth: "160px" }}>
                    <div style={{ fontSize: "13px", color: "#9CA3AF" }}>
                      Система
                    </div>
                    <div>{user.canopySystem || "-"}</div>
                  </div>

                  {/* ПРЫЖКИ */}
                  <div style={{ minWidth: "120px" }}>
                    <div style={{ fontSize: "13px", color: "#9CA3AF" }}>
                      Прыжки
                    </div>
                    <div>{user.jumpCount || 0}</div>
                  </div>

                  {/* КНОПКИ */}
                  <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                    <div
                      style={{
                        minWidth: "160px",
                        maxWidth: "160px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                      }}
                    >
                      {activeTab === "friends" && (
                        <div style={{ display: "flex", gap: "6px" }}>

                          {/* ПРОФИЛЬ */}
                          <button
                            onClick={() =>
                              window.open(`/u/${user.publicId}`, "_blank")
                            }
                            style={{
                              padding: "6px 10px",
                              borderRadius: "6px",
                              background: "#10B981",
                              border: "none",
                              cursor: "pointer",
                              whiteSpace: "nowrap"
                            }}
                          >
                            Профиль
                          </button>

                          {/* УДАЛИТЬ */}
                          <div style={{ position: "relative" }}>
                            <button
                              onClick={() => removeFriend(user.id)}
                              style={{
                                width: "32px",
                                height: "32px",
                                borderRadius: "6px",
                                background: "transparent",
                                border: "1px solid #EF4444",
                                color: "#EF4444",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "14px",
                                transition: "all 0.2s ease"
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background = "#EF4444";
                                e.currentTarget.style.color = "#fff";
                                const tooltip = e.currentTarget.nextSibling;
                                if (tooltip) tooltip.style.opacity = "1";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background = "transparent";
                                e.currentTarget.style.color = "#EF4444";
                                const tooltip = e.currentTarget.nextSibling;
                                if (tooltip) tooltip.style.opacity = "0";
                              }}
                            >
                              🗑
                            </button>
                            {/* TOOLTIP */}
                            <div
                              style={{
                                position: "absolute",
                                bottom: "110%",
                                right: "0",
                                background: "#111827",
                                color: "#fff",
                                padding: "4px 8px",
                                borderRadius: "6px",
                                fontSize: "12px",
                                whiteSpace: "nowrap",
                                opacity: 0,
                                pointerEvents: "none",
                                transition: "opacity 0.2s",
                                boxShadow: "0 4px 10px rgba(0,0,0,0.4)"
                              }}
                            >
                              Удалить из друзей
                            </div>
                          </div>
                        </div>
                      )}

                      {/* НЕ ДРУГ */}
                      {activeTab === "global" && !user.publicId && (
                        <button
                          onClick={() => addFriend(user.id)}
                          style={{
                            padding: "6px 12px",
                            borderRadius: "6px",
                            background: "#2563EB",
                            border: "none",
                            cursor: "pointer",
                            whiteSpace: "nowrap"
                          }}
                        >
                          Подписаться
                        </button>
                      )}

                      {/* ДРУГ */}
                      {activeTab === "global" && user.publicId && (
                        <div style={{ display: "flex", gap: "6px" }}>

                          {/* ПРОФИЛЬ */}
                          <button
                            onClick={() =>
                              window.open(`/u/${user.publicId}`, "_blank")
                            }
                            style={{
                              padding: "6px 10px",
                              borderRadius: "6px",
                              background: "#10B981",
                              border: "none",
                              cursor: "pointer",
                              whiteSpace: "nowrap"
                            }}
                          >
                            Профиль
                          </button>

                          {/* УДАЛИТЬ */}
                          <div style={{ position: "relative" }}>
                            <button
                              onClick={() => removeFriend(user.id)}
                              style={{
                                width: "32px",
                                height: "32px",
                                borderRadius: "6px",
                                background: "transparent",
                                border: "1px solid #EF4444",
                                color: "#EF4444",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "14px",
                                transition: "all 0.2s ease"
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background = "#EF4444";
                                e.currentTarget.style.color = "#fff";
                                const tooltip = e.currentTarget.nextSibling;
                                if (tooltip) tooltip.style.opacity = "1";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background = "transparent";
                                e.currentTarget.style.color = "#EF4444";
                                const tooltip = e.currentTarget.nextSibling;
                                if (tooltip) tooltip.style.opacity = "0";
                              }}
                            >
                              🗑
                            </button>
                            {/* TOOLTIP */}
                            <div
                              style={{
                                position: "absolute",
                                bottom: "110%",
                                right: "0",
                                background: "#111827",
                                color: "#fff",
                                padding: "4px 8px",
                                borderRadius: "6px",
                                fontSize: "12px",
                                whiteSpace: "nowrap",
                                opacity: 0,
                                pointerEvents: "none",
                                transition: "opacity 0.2s",
                                boxShadow: "0 4px 10px rgba(0,0,0,0.4)"
                              }}
                            >
                              Удалить из друзей
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* КНОПКА ЗАКРЫТЬ */}
            < button
              onClick={() => setFriendsModalOpen(false)}
              style={{
                marginTop: "20px",
                width: "100%",
                padding: "10px",
                borderRadius: "10px",
                border: "none",
                background: "#1a2247",
                color: "#fff",
                cursor: "pointer"
              }}
            >
              Закрыть
            </button>
          </div>
        </div>
      )
      }
    </div >
  );
};

// Стили

const sectionStyle = {
  backgroundColor: "rgba(31, 41, 55, 0.7)",
  padding: "25px 30px",
  borderRadius: "16px",
  backdropFilter: "blur(6px)",
  boxShadow: "0 6px 18px rgba(0,0,0,0.4)",
  minWidth: 0,
};

const sectionTitleStyle = {
  marginBottom: "18px",
  fontSize: "20px",
  // color: "#D1D5DB",
  borderBottom: "1px solid rgba(255,255,255,0.2)",
  paddingBottom: "8px",
};

const tableStyle = {
  width: "100%",
  borderSpacing: "8px",
  color: "#F3F4F6",
};

const menuItemStyle = {
  padding: "10px",
  cursor: "pointer",
  color: "#F3F4F6",
  borderRadius: "8px",
  transition: "background 0.2s",
  textAlign: "left",
};

const modalOverlayStyle = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.65)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2000,
};

const modalStyle = {
  backgroundColor: "rgba(17, 24, 39, 0.95)",
  borderRadius: "16px",
  padding: "30px",
  width: "100%",
  maxWidth: "420px",
  boxShadow: "0 20px 40px rgba(0,0,0,0.6)",
  color: "#F3F4F6",
};

const modalTitleStyle = {
  fontSize: "22px",
  marginBottom: "20px",
};

const labelStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "6px",
  marginBottom: "14px",
  fontSize: "14px",
};

const inputStyle = {
  padding: "10px",
  borderRadius: "8px",
  border: "1px solid rgba(255,255,255,0.2)",
  backgroundColor: "rgba(31, 41, 55, 0.9)",
  color: "#F3F4F6",
  outline: "none",
  width: "100%",
boxSizing: "border-box",
};
const nameStyle = {
  fontSize: "30px",
  marginBottom: "20px",
};

const avatarStyle = {
  width: "160px",
  height: "160px",
  borderRadius: "50%",
  objectFit: "cover",
  border: "3px solid #10B981",
};

const headerStyle = {
  display: "flex",
  gap: "30px",
  backgroundColor: "rgba(17, 24, 39, 0.75)",
  padding: "30px",
  borderRadius: "16px",
  marginBottom: "30px",
};
const saveBtnStyle = {
  flex: 1,
  padding: "12px",
  borderRadius: "10px",
  border: "none",
  backgroundColor: "#10B981",
  color: "#022C22",
  fontWeight: "600",
  cursor: "pointer",
};

const cancelBtnStyle = {
  flex: 1,
  padding: "12px",
  borderRadius: "10px",
  border: "1px solid rgba(255,255,255,0.2)",
  backgroundColor: "transparent",
  color: "#F3F4F6",
  cursor: "pointer",
};
export default SkydiverProfile;
